import { ComunidadeIuppService as Service } from '../Services/ComunidadeIupp/ComunidadeIuup'

export async function getStores (filter) {
  const response = await Service.getUnitys(filter)
  return response.data.objectReturn.data
}

export async function getOffers (filter) {
  const response = await Service.getOffers(filter)
  return response.data.objectReturn.data
}

export async function getLocationFromZipCode (zipCode) {
  const { data } = await Service.getLocation(zipCode)
  const { objectReturn: { location: { lat, lng } } } = data

  return { latitude: lat, longitude: lng }
}



// WEBPACK FOOTER //
// ./src/features/MeuBairro/effects.js